var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.85,
    y: 0.85,
    width: 22.3,
    height: 22.3,
    rx: 4.15,
    stroke: "#FCD700",
    strokeWidth: 1.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9858 8.43018C17.0258 8.43018 17.9658 8.88018 18.6258 9.59018L17.5258 10.6102C17.1058 10.2302 16.5758 10.0302 15.9858 10.0302C14.9458 10.0302 14.1258 10.8002 14.1258 12.0002C14.1258 13.2002 14.9458 13.9602 15.9858 13.9602C16.5758 13.9602 17.1058 13.7702 17.5258 13.3902L18.6258 14.4102C17.9658 15.1202 17.0258 15.5702 15.9858 15.5702C14.0158 15.5702 12.4258 13.9702 12.4258 12.0002C12.4258 10.0302 14.0158 8.43018 15.9858 8.43018Z",
    fill: "#FCD700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.995 15.5001H9.295V11.6501L6.395 15.5001H5.375V8.50012H7.075V12.3501L9.975 8.50012H10.995V15.5001Z",
    fill: "#FCD700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsYellow);
export default __webpack_public_path__ + "static/media/is_yellow.011db099434294c785deb0edee96e6f1.svg";
export { ForwardRef as ReactComponent };